import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  parseServiceOutput,
  requestConfig,
} from "../../globals";
import { getAuth } from "../../utils";
import { type Registration, registration } from "../schemas/registration";
import { registrationInput } from "../schemas/registration.input";

export const registerAccountProps = z
  .object({ registration: registrationInput })
  .extend(requestConfig.shape);

export type RegisterAccountProps = z.infer<typeof registerAccountProps>;

export const registerAccount = async (
  args: RegisterAccountProps,
): Promise<Registration> => {
  const {
    brand,
    market,
    endpoint = env.ACCOUNT_SERVICE_URL,
    auth: Authorization = getAuth(),
    registration: registrationInput,
    proxyAuthSecret,
  } = parseServiceInput(registerAccountProps, args);

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization,
    ...(proxyAuthSecret ? { "X-NG-Proxy-Auth": proxyAuthSecret } : {}),
  });

  const response = await fetch(`${endpoint}/v3/auth/register`, {
    method: "POST",
    headers,
    body: JSON.stringify({
      ...registrationInput,
      countryCode: market,
      brand,
    }),
  });

  return parseServiceOutput(response, registration, {
    code: "MALFORMED_REGISTRATION",
    message: "Registration is malformed",
  });
};
